import { render } from "./NFTGrid.vue?vue&type=template&id=603b6762&ts=true"
import script from "./NFTGrid.vue?vue&type=script&lang=ts"
export * from "./NFTGrid.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Domingos\\Documents\\GitHub\\staking-fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__